import React from 'react'
import {Field} from "formik";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";
import Separator from "components/Form/Separator";

const styles = {
    textField33: {
        display: 'inline-block', width: '33%'
    }
}

const AgeForm = ({ element }) => (

    <div>
        <Field type="number" name="ageMaxBaby" customlabel="Âge maximum des bébés" component={CustomInputTextComponent} required/>
        <div style={{width:'100%'}}>
            <div style={{...styles.textField33, paddingRight:10}}>
                <Field type="text" name="ageBabyBoyPrefix" customlabel="Préfixe garçon" component={CustomInputTextComponent} required/>
            </div>
            <div style={{...styles.textField33, paddingLeft:10, paddingRight:10}}>
                <Field type="text" name="ageBabyGirlPrefix" customlabel="Préfixe fille" component={CustomInputTextComponent} required/>
            </div>
            <div style={{...styles.textField33, paddingLeft:10}}>
                <Field type="text" name="ageBabyOtherPrefix" customlabel="Préfixe autre" component={CustomInputTextComponent} required/>
            </div>
        </div>

        <Separator style={{marginTop:20, marginBottom:20}}/>

        <Field type="number" name="ageMaxChild" customlabel="Âge maximum des enfants" component={CustomInputTextComponent} required/>
        <div style={{width:'100%'}}>
            <div style={{...styles.textField33, paddingRight:10}}>
                <Field type="text" name="ageChildBoyPrefix" customlabel="Préfixe garçon" component={CustomInputTextComponent} required/>
            </div>
            <div style={{...styles.textField33, paddingLeft:10, paddingRight:10}}>
                <Field type="text" name="ageChildGirlPrefix" customlabel="Préfixe fille" component={CustomInputTextComponent} required/>
            </div>
            <div style={{...styles.textField33, paddingLeft:10}}>
                <Field type="text" name="ageChildOtherPrefix" customlabel="Préfixe autre" component={CustomInputTextComponent} required/>
            </div>
        </div>


        <Separator style={{marginTop:20, marginBottom:20}}/>

        <div style={{width:'100%'}}>
            <div style={{...styles.textField33, paddingRight:10}}>
                <Field type="text" name="ageManPrefix" customlabel="Préfixe homme" component={CustomInputTextComponent} required/>
            </div>
            <div style={{...styles.textField33, paddingLeft:10, paddingRight:10}}>
                <Field type="text" name="ageWomanPrefix" customlabel="Préfixe femme" component={CustomInputTextComponent} required/>
            </div>
            <div style={{...styles.textField33, paddingLeft:10}}>
                <Field type="text" name="ageOtherPrefix" customlabel="Préfixe autre" component={CustomInputTextComponent} required/>
            </div>
        </div>

    </div>


)

export default AgeForm